/* ══════════════════════════════════════════════════════════════
   yes!piece — Kontakt-Überschrift im Footer verlinken
   Macht die Überschrift des Footer-Kontaktblocks zu einem Link auf
   das Kontaktformular. Voraussetzung: Der Block ist mobil dauerhaft
   aufgeklappt (open_default aktiv), da die Klappfunktion neutralisiert
   wird. Update-fest: verändert keine Theme-Datei.

   >>> Ziel-URL bei Bedarf hier anpassen: <<<
   ══════════════════════════════════════════════════════════════ */
(function () {
  var ZIEL_URL = '/pages/contact';   // <-- Pfad zum Kontaktformular
  var UEBERSCHRIFT = 'kontakt';        // welcher Block? Vergleich in Kleinschreibung

  function init() {
    var headings = document.querySelectorAll('.footer .footer-block__heading');
    headings.forEach(function (h) {
      // schon verlinkt? überspringen
      if (h.querySelector('a.yp-heading-link')) return;

      var text = (h.textContent || '').trim();
      if (text.toLowerCase() !== UEBERSCHRIFT) return;

      // Text in einen Link verwandeln
      var a = document.createElement('a');
      a.className = 'yp-heading-link';
      a.href = ZIEL_URL;
      a.textContent = text;
      h.textContent = '';
      h.appendChild(a);

      // Klappfunktion neutralisieren: <summary> soll nicht mehr auf-/zuklappen.
      // Das umschließende <details> auf "offen" festsetzen.
      var summary = h.closest('summary');
      if (summary) {
        var details = summary.closest('details');
        if (details) { details.setAttribute('open', ''); }
        // Klick auf den Link nicht vom summary abfangen lassen
        a.addEventListener('click', function (e) {
          e.stopPropagation();
          // Standard-Navigation zulassen; verhindern, dass details toggelt
          if (details) { details.setAttribute('open', ''); }
        });
        // Klick woanders im summary (nicht auf dem Link) nicht mehr toggeln
        summary.addEventListener('click', function (e) {
          if (e.target.closest('a.yp-heading-link')) return; // Link-Klick durchlassen
          e.preventDefault();
        });
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();